export default __webpack_public_path__ + "static/media/video-black.3154b141.svg";